import type { PaymentModuleId } from '@foundation/apis/payments';
import { Theme } from '@pmi.web/react-theme';

export interface IPaymentIntent {
  readonly id: string;
  readonly customer: IPaymentIntentCustomer;
  readonly order: IPaymentIntentOrder;
  readonly urls: IPaymentIntentUrls;
  readonly isPayable: boolean;
}

export interface IPaymentIntentCustomer {
  readonly legalEntityNumber: number;
  readonly number: number;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly email: string | null;
  readonly phone: string | null;
  readonly company: string | null;
  readonly shippingAddress: IPaymentIntentShipping;
  readonly telemetryConsent: boolean;
  readonly flow: PaymentIntentFlow;
  readonly theme?: Theme;
  readonly allowedPaymentMethods: ReadonlyArray<PaymentModuleId>;
  readonly preSelectedPaymentMethod: PaymentModuleId | undefined;
  readonly skip3DS: boolean;
}

export interface IPaymentIntentShipping {
  readonly firstName: string;
  readonly lastName: string;
  readonly company: string;
  readonly streetAddress: string;
  readonly extendedAddress: string;
  readonly locality: string;
  readonly postalCode: string;
  readonly region: string;
  readonly countryCode: string;
}

export interface IPaymentIntentOrder {
  readonly number: string;
  readonly amount: number;
  readonly currency: string;
}

export interface IPaymentIntentUrls {
  readonly notification: string;
  readonly cancel: string;
  readonly failure: string;
  readonly success: string;
}

export enum PaymentIntentStatus {
  Created = 'created',
  Unknown = 'unknown',
  SentForAuthorisation = 'sent_for_authorisation',
  Authorized = 'authorized',
  SubmittedForSettlement = 'submitted_for_settlement',
  Settling = 'settling',
  SettlementPending = 'settlement_pending',
  ProcessorDeclined = 'processor_declined',
  GatewayRejected = 'gateway_rejected',
  Failed = 'failed',
  SentForVoiding = 'sent_for_voiding',
  Voided = 'voided',
  AuthorizationExpired = 'authorization_expired',
  Settled = 'settled',
  SettlementDeclined = 'settlement_declined',
  Disbursed = 'disbursed',
  SentForRefund = 'sent_for_refund',
  PartiallyRefunded = 'partially_refunded',
  FullyRefunded = 'fully_refunded',
}

export enum PaymentIntentFlow {
  Cit = 'cit',
  Moto = 'moto',
  Manage = 'manage',
  Events = 'events',
}
